var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0002 7.79922C4.33745 7.79922 3.8002 8.33648 3.8002 8.99922V17.9992C3.8002 18.662 4.33745 19.1992 5.0002 19.1992H19.0002C19.6629 19.1992 20.2002 18.662 20.2002 17.9992V8.99922C20.2002 8.33648 19.6629 7.79922 19.0002 7.79922H17.3002V6.19922H19.0002C20.5466 6.19922 21.8002 7.45282 21.8002 8.99922V17.9992C21.8002 19.5456 20.5466 20.7992 19.0002 20.7992H5.0002C3.4538 20.7992 2.2002 19.5456 2.2002 17.9992V8.99922C2.2002 7.45282 3.4538 6.19922 5.0002 6.19922H6.7002V7.79922H5.0002Z",
    fill: "#7F818A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8 8V6C8.8 5.55817 8.44183 5.2 8 5.2C7.55817 5.2 7.2 5.55817 7.2 6V8C7.2 8.44183 7.55817 8.8 8 8.8C8.44183 8.8 8.8 8.44183 8.8 8ZM8 4C6.89543 4 6 4.89543 6 6V8C6 9.10457 6.89543 10 8 10C9.10457 10 10 9.10457 10 8V6C10 4.89543 9.10457 4 8 4Z",
    fill: "#7F818A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8 8V6C16.8 5.55817 16.4418 5.2 16 5.2C15.5582 5.2 15.2 5.55817 15.2 6V8C15.2 8.44183 15.5582 8.8 16 8.8C16.4418 8.8 16.8 8.44183 16.8 8ZM16 4C14.8954 4 14 4.89543 14 6V8C14 9.10457 14.8954 10 16 10C17.1046 10 18 9.10457 18 8V6C18 4.89543 17.1046 4 16 4Z",
    fill: "#7F818A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 13,
    r: 0.5,
    stroke: "#7F818A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 13,
    r: 0.5,
    stroke: "#7F818A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13,
    r: 0.5,
    stroke: "#7F818A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 13,
    r: 0.5,
    stroke: "#7F818A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 16,
    r: 0.5,
    stroke: "#7F818A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 16,
    r: 0.5,
    stroke: "#7F818A"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 16,
    r: 0.5,
    stroke: "#7F818A"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 0.5,
    stroke: "#7F818A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6.30078,
    width: 6,
    height: 1.6,
    fill: "#7F818A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6ccf6ebbbc2159468eefe792ea8d192c.svg";
export { ForwardRef as ReactComponent };